import { render, staticRenderFns } from "./ResidencyVideoElem.vue?vue&type=template&id=27964669&scoped=true&"
import script from "./ResidencyVideoElem.vue?vue&type=script&lang=js&"
export * from "./ResidencyVideoElem.vue?vue&type=script&lang=js&"
import style0 from "./ResidencyVideoElem.vue?vue&type=style&index=0&id=27964669&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27964669",
  null
  
)

export default component.exports